import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { PreschoolScoreReport } = Views;

const reportsRouter = {
  path: "/report",
  component: Layout,
  redirect: "dashboard",
  name: "Report",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "preschool-score-report",
      name: "PreschoolScoreReport",
      component: PreschoolScoreReport,
      meta: {
        requiresAuth: true,
      },
    }
  ],
};

export default reportsRouter;
